import { defineComponent } from 'vue'
import type { DropdownItemProps } from './types'

const DropdownItem = defineComponent<DropdownItemProps>({
  setup(props) {
    const handleClick = () => {
      if (props.item.onClick) {
        props.item.onClick(props.item)
      }
    }

    return () => {
      const label = props.item.label || ''
      const testid = `dropdown-item-${label.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}`
      return (
        <li onClick={handleClick} data-testid={testid}>
          <div
            class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
          >
            {label}
          </div>
        </li>
      )
    }
  }
})

DropdownItem.props = ['item']

export default DropdownItem
